import {
  ProductType,
  Quote,
  QuoteUnavailabilityReasonType,
  Status,
} from '@generated/gql/graphql';

import { CategorizedProducts, ProductKeys } from './types';

const categorizeProduct = (
  productType: ProductKeys,
  categorizedProducts: CategorizedProducts,
  quote: Quote
): CategorizedProducts => {
  const {
    product: { type },
    status: { status, reasons },
    selected,
  } = quote;

  if (productType !== type) {
    return categorizedProducts;
  }

  if (
    status === Status.Unavailable &&
    reasons?.some(
      ({ type }) => type === QuoteUnavailabilityReasonType.Expired
    ) &&
    selected
  ) {
    categorizedProducts[productType].expired.push(quote);
  }

  if (status === Status.Available && !selected) {
    categorizedProducts[productType].available.push(quote);
  }

  return categorizedProducts;
};

const categorizeQuotes = (quotes: Quote[]) =>
  quotes.reduce(
    (acc, quote) => {
      acc = categorizeProduct(ProductType.Energy, acc, quote);
      acc = categorizeProduct(ProductType.Broadband, acc, quote);
      acc = categorizeProduct(ProductType.Mobile, acc, quote);
      acc = categorizeProduct(ProductType.Insurance, acc, quote);

      return acc;
    },
    {
      [ProductType.Energy]: { available: [], expired: [] },
      [ProductType.Broadband]: { available: [], expired: [] },
      [ProductType.Mobile]: { available: [], expired: [] },
      [ProductType.Insurance]: { available: [], expired: [] },
    } as CategorizedProducts
  );

const hasExpiredQuotes = (categorizedQuotes: CategorizedProducts) =>
  Object.values(categorizedQuotes).some(
    (category) => category.expired.length > 0
  );

export { categorizeQuotes, categorizeProduct, hasExpiredQuotes };
